import { Injectable, inject } from '@angular/core';
import { ContextType, ChatMessage, ChatRole } from '../models/agent.models';
import { MessagesStateService } from './messages-state.service';
import { UserService } from '@dataclouder/ngx-users';

@Injectable({
  providedIn: 'root',
})
export class ContextEngineService {
  private messagesStateSvc = inject(MessagesStateService);
  private userService = inject(UserService);

  public getUserData(): string {
    return this.userService.getUserDataInformation();
  }

  // TODO: este me va a ayudar a sacar contexto a las entities solo necesito mejorarlo
  public getEntityContext<T extends { id: string; name: string; description?: string }>(entity: T) {
    return null;
  }

  public getConversationContext(contextType: ContextType): string {
    const contextMessages = this.getContextMessages(contextType);
    return contextMessages.map((message) => `${message.role}: ${message.content}`).join('\n');
  }

  public getContextMessages(contextType: ContextType): ChatMessage[] {
    const messages = this.messagesStateSvc.getMessagesSignal()();

    const conversationMessages = messages.filter((message) => [ChatRole.User, ChatRole.Assistant].includes(message.role));

    if (conversationMessages.length === 0) {
      return [];
    }

    switch (contextType) {
      case ContextType.LastAssistantMessage: {
        const lastAssistant = conversationMessages
          .slice()
          .reverse()
          .find((m) => m.role === ChatRole.Assistant);
        return lastAssistant ? [lastAssistant] : [];
      }
      case ContextType.LastUserMessage: {
        const lastUser = conversationMessages
          .slice()
          .reverse()
          .find((m) => m.role === ChatRole.User);
        return lastUser ? [lastUser] : [];
      }
      case ContextType.LastMessage: {
        const lastUser = conversationMessages
          .slice()
          .reverse()
          .find((m) => m.role === ChatRole.User);
        const lastAssistant = conversationMessages
          .slice()
          .reverse()
          .find((m) => m.role === ChatRole.Assistant);
        const dialog: ChatMessage[] = [];
        if (lastAssistant) dialog.push(lastAssistant);
        if (lastUser) dialog.push(lastUser);
        return dialog;
      }
      case ContextType.Last2Messages: {
        return conversationMessages.slice(-2);
      }
      case ContextType.Last3Messages: {
        return conversationMessages.slice(-3);
      }
      case ContextType.Last4Messages: {
        return conversationMessages.slice(-4);
      }
      case ContextType.LastUserAndPreviousAssistant: {
        const lastUserIndex = conversationMessages.map((m) => m.role).lastIndexOf(ChatRole.User);

        if (lastUserIndex <= 0) {
          return [];
        }

        const messages = conversationMessages.slice(lastUserIndex - 1, lastUserIndex + 1);
        console.log('LastUserAndPreviousAssistant', messages);
        return messages;
      }
      case ContextType.AllConversation:
      default:
        return conversationMessages;
    }
  }
}
